<!-- 健康促进中心 / 中心介绍 -->
<template>
    <div class="lang">
        <div class="info">
            <div class="full-width"><img src="/resource/img/center-bg.jpg" alt="" class="full-width--bg">
                <h3 class="title01">Wellness Center</h3>
                <h4 class="title03">
                    福祉是一个既包含“幸福”又包含“健康”的概念, 是身体.
                    心理和社会健康的和谐幸福生活的基础.
                    健康促进中心为您提供可靠的健康管理服务
                    是为您提供健康快乐生活的伴侣.</h4>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">定制程序</h3>
            <p class="bullet03 depth">我们根据每位客户的个人特点, 通过与上门就诊时与协调员一对一的咨询, 或通过我们在互联网上的“快乐电话”服务或电话预订, 提供定制的计划.</p>
            <p class="bullet03 depth">我们建立了一个适合各人不同特点的独特计划, 其中的选项很容易选择.</p>
            <p class="bullet03 depth">我们部署了一个智能系统, 可在线医疗咨询, 并参考个人的家庭病史、生活习惯和不适症状, 使得这些信息可用于确定是否需要进一步检查并分析体检结果.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">借助最新的医疗设施和经验丰富的医务人员, 进行准确的体检</h3>
            <p class="bullet03 depth">我们拥有经验丰富的医疗团队, 专门为健康促进中心服务, 医疗人员由各部门的合作教授组成, 他们可以迅速和紧密地相互联系.</p>
            <p class="bullet03 depth">为了提高诊断的准确性, 我们配备了各种不同的尖端医疗设备, 包括CT、MRI、超声、PET和内窥镜.</p>
            <p class="bullet03 depth">一旦诊断出癌症或其他严重疾病, 健康促进中心的专门医务人员和协调员将立即按部就班地将您与门诊治疗对接.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">提供优雅的体检体验</h3>
            <p class="bullet03 depth">我们门诊宽敞的布局和舒适的候诊空间将使您体验到令人愉快的体检过程.</p>
            <p class="bullet03 depth">对于希望升级为豪华体检的人来说，可以选择贵宾候诊室和病床.</p>
        </div>
    </div>
</template>
<script>

    export default {
    }

</script>